var map = {
	"./views/activity/assemble": "/27t",
	"./views/activity/assemble/": "/27t",
	"./views/activity/assemble/add": "F5FJ",
	"./views/activity/assemble/add.vue": "F5FJ",
	"./views/activity/assemble/edit": "OaSy",
	"./views/activity/assemble/edit.vue": "OaSy",
	"./views/activity/assemble/index": "/27t",
	"./views/activity/assemble/index.vue": "/27t",
	"./views/activity/assemble/list": "J2ms",
	"./views/activity/assemble/list.vue": "J2ms",
	"./views/activity/assemble/my": "nUHE",
	"./views/activity/assemble/my.vue": "nUHE",
	"./views/activity/assemble/part/Info": "X1+Z",
	"./views/activity/assemble/part/Info.vue": "X1+Z",
	"./views/activity/assemble/part/Other": "3vT7",
	"./views/activity/assemble/part/Other.vue": "3vT7",
	"./views/activity/assemble/part/Spec": "rgBB",
	"./views/activity/assemble/part/Spec.vue": "rgBB",
	"./views/activity/bargain": "QJIn",
	"./views/activity/bargain/": "QJIn",
	"./views/activity/bargain/add": "08F7",
	"./views/activity/bargain/add.vue": "08F7",
	"./views/activity/bargain/edit": "nw5L",
	"./views/activity/bargain/edit.vue": "nw5L",
	"./views/activity/bargain/index": "QJIn",
	"./views/activity/bargain/index.vue": "QJIn",
	"./views/activity/bargain/list": "MF1Q",
	"./views/activity/bargain/list.vue": "MF1Q",
	"./views/activity/bargain/my": "TnJW",
	"./views/activity/bargain/my.vue": "TnJW",
	"./views/activity/bargain/part/Info": "J77i",
	"./views/activity/bargain/part/Info.vue": "J77i",
	"./views/activity/bargain/part/Other": "33K3",
	"./views/activity/bargain/part/Other.vue": "33K3",
	"./views/activity/bargain/part/Spec": "qICA",
	"./views/activity/bargain/part/Spec.vue": "qICA",
	"./views/activity/point/add": "hiAW",
	"./views/activity/point/add.vue": "hiAW",
	"./views/activity/point/edit": "lhld",
	"./views/activity/point/edit.vue": "lhld",
	"./views/activity/point/my": "u2D5",
	"./views/activity/point/my.vue": "u2D5",
	"./views/activity/point/part/Info": "rG3O",
	"./views/activity/point/part/Info.vue": "rG3O",
	"./views/activity/point/part/Other": "D11S",
	"./views/activity/point/part/Other.vue": "D11S",
	"./views/activity/point/part/Spec": "aXu8",
	"./views/activity/point/part/Spec.vue": "aXu8",
	"./views/activity/seckill": "8zsP",
	"./views/activity/seckill/": "8zsP",
	"./views/activity/seckill/add": "4qvU",
	"./views/activity/seckill/add.vue": "4qvU",
	"./views/activity/seckill/edit": "ZmIS",
	"./views/activity/seckill/edit.vue": "ZmIS",
	"./views/activity/seckill/index": "8zsP",
	"./views/activity/seckill/index.vue": "8zsP",
	"./views/activity/seckill/list": "abvl",
	"./views/activity/seckill/list.vue": "abvl",
	"./views/activity/seckill/my": "WYu6",
	"./views/activity/seckill/my.vue": "WYu6",
	"./views/activity/seckill/part/Info": "cGGy",
	"./views/activity/seckill/part/Info.vue": "cGGy",
	"./views/activity/seckill/part/Other": "oJEo",
	"./views/activity/seckill/part/Other.vue": "oJEo",
	"./views/activity/seckill/part/Spec": "Ej6I",
	"./views/activity/seckill/part/Spec.vue": "Ej6I",
	"./views/auth/loginlog": "5n4C",
	"./views/auth/loginlog/": "5n4C",
	"./views/auth/loginlog/index": "5n4C",
	"./views/auth/loginlog/index.vue": "5n4C",
	"./views/auth/optlog": "rES7",
	"./views/auth/optlog/": "rES7",
	"./views/auth/optlog/dialog/Detail": "WGhd",
	"./views/auth/optlog/dialog/Detail.vue": "WGhd",
	"./views/auth/optlog/index": "rES7",
	"./views/auth/optlog/index.vue": "rES7",
	"./views/auth/role": "XCfr",
	"./views/auth/role/": "XCfr",
	"./views/auth/role/add": "t8zw",
	"./views/auth/role/add.vue": "t8zw",
	"./views/auth/role/edit": "qoOx",
	"./views/auth/role/edit.vue": "qoOx",
	"./views/auth/role/index": "XCfr",
	"./views/auth/role/index.vue": "XCfr",
	"./views/auth/user": "r32Q",
	"./views/auth/user/": "r32Q",
	"./views/auth/user/dialog/Add": "OrNz",
	"./views/auth/user/dialog/Add.vue": "OrNz",
	"./views/auth/user/dialog/Edit": "tQNW",
	"./views/auth/user/dialog/Edit.vue": "tQNW",
	"./views/auth/user/index": "r32Q",
	"./views/auth/user/index.vue": "r32Q",
	"./views/cash/cash": "aP56",
	"./views/cash/cash/": "aP56",
	"./views/cash/cash/account": "6Bs8",
	"./views/cash/cash/account.vue": "6Bs8",
	"./views/cash/cash/index": "aP56",
	"./views/cash/cash/index.vue": "aP56",
	"./views/cash/cash/lists": "ONoF",
	"./views/cash/cash/lists.vue": "ONoF",
	"./views/cash/dialog/Apply": "H6WS",
	"./views/cash/dialog/Apply.vue": "H6WS",
	"./views/cash/settled": "s8tA",
	"./views/cash/settled/": "s8tA",
	"./views/cash/settled/detail": "CinV",
	"./views/cash/settled/detail.vue": "CinV",
	"./views/cash/settled/index": "s8tA",
	"./views/cash/settled/index.vue": "s8tA",
	"./views/chat/chat": "N3cY",
	"./views/chat/chat/": "N3cY",
	"./views/chat/chat/index": "N3cY",
	"./views/chat/chat/index.vue": "N3cY",
	"./views/chat/chat/list": "oBmj",
	"./views/chat/chat/list.vue": "oBmj",
	"./views/chat/chat/record": "mThO",
	"./views/chat/chat/record.vue": "mThO",
	"./views/coupon": "Vk0n",
	"./views/coupon/": "Vk0n",
	"./views/coupon/coupon": "6vgH",
	"./views/coupon/coupon/": "6vgH",
	"./views/coupon/coupon/Receive": "C0y5",
	"./views/coupon/coupon/Receive.vue": "C0y5",
	"./views/coupon/coupon/SendCoupon": "ZRvh",
	"./views/coupon/coupon/SendCoupon.vue": "ZRvh",
	"./views/coupon/coupon/add": "wGhw",
	"./views/coupon/coupon/add.vue": "wGhw",
	"./views/coupon/coupon/edit": "cwCa",
	"./views/coupon/coupon/edit.vue": "cwCa",
	"./views/coupon/coupon/index": "6vgH",
	"./views/coupon/coupon/index.vue": "6vgH",
	"./views/coupon/index": "Vk0n",
	"./views/coupon/index.vue": "Vk0n",
	"./views/error-page/404": "LWjT",
	"./views/error-page/404.vue": "LWjT",
	"./views/home/home": "zKIK",
	"./views/home/home.vue": "zKIK",
	"./views/home/part/Product": "wxW3",
	"./views/home/part/Product.vue": "wxW3",
	"./views/home/part/Total": "Pkpl",
	"./views/home/part/Total.vue": "Pkpl",
	"./views/home/part/Transaction": "3IeZ",
	"./views/home/part/Transaction.vue": "3IeZ",
	"./views/home/part/product/LineChart": "e8sB",
	"./views/home/part/product/LineChart.vue": "e8sB",
	"./views/home/part/product/Ranking": "hzcc",
	"./views/home/part/product/Ranking.vue": "hzcc",
	"./views/home/part/product/Total": "HjpG",
	"./views/home/part/product/Total.vue": "HjpG",
	"./views/layout/Head": "RCdB",
	"./views/layout/Head.vue": "RCdB",
	"./views/layout/LeftMenu": "YAez",
	"./views/layout/LeftMenu.vue": "YAez",
	"./views/layout/RightContent": "Kj90",
	"./views/layout/RightContent.vue": "Kj90",
	"./views/layout/main": "5Zhu",
	"./views/layout/main.vue": "5Zhu",
	"./views/layout/part/UpdatePassword": "8Q4f",
	"./views/layout/part/UpdatePassword.vue": "8Q4f",
	"./views/live": "Vorc",
	"./views/live/": "Vorc",
	"./views/live/index": "Vorc",
	"./views/live/index.vue": "Vorc",
	"./views/live/order/list": "W+rW",
	"./views/live/order/list.vue": "W+rW",
	"./views/live/room/dialog/Edit": "Q2TU",
	"./views/live/room/dialog/Edit.vue": "Q2TU",
	"./views/live/room/dialog/Gift": "JSHA",
	"./views/live/room/dialog/Gift.vue": "JSHA",
	"./views/live/room/dialog/Products": "YPo8",
	"./views/live/room/dialog/Products.vue": "YPo8",
	"./views/live/room/room": "zAPi",
	"./views/live/room/room.vue": "zAPi",
	"./views/login": "Quw4",
	"./views/login.vue": "Quw4",
	"./views/operate/ad": "I/hH",
	"./views/operate/ad/": "I/hH",
	"./views/operate/ad/add": "765p",
	"./views/operate/ad/add.vue": "765p",
	"./views/operate/ad/edit": "ygPA",
	"./views/operate/ad/edit.vue": "ygPA",
	"./views/operate/ad/index": "I/hH",
	"./views/operate/ad/index.vue": "I/hH",
	"./views/operate/fans": "IuDE",
	"./views/operate/fans/": "IuDE",
	"./views/operate/fans/index": "IuDE",
	"./views/operate/fans/index.vue": "IuDE",
	"./views/order/agent": "qkpN",
	"./views/order/agent/": "qkpN",
	"./views/order/agent/index": "qkpN",
	"./views/order/agent/index.vue": "qkpN",
	"./views/order/order": "B35p",
	"./views/order/order/": "B35p",
	"./views/order/order/detail": "aZ+E",
	"./views/order/order/detail.vue": "aZ+E",
	"./views/order/order/dialog/Add": "pbqi",
	"./views/order/order/dialog/Add.vue": "pbqi",
	"./views/order/order/dialog/cancel": "KyyG",
	"./views/order/order/dialog/cancel.vue": "KyyG",
	"./views/order/order/index": "B35p",
	"./views/order/order/index.vue": "B35p",
	"./views/order/refund": "sz9h",
	"./views/order/refund/": "sz9h",
	"./views/order/refund/detail": "n2/w",
	"./views/order/refund/detail.vue": "n2/w",
	"./views/order/refund/index": "sz9h",
	"./views/order/refund/index.vue": "sz9h",
	"./views/product/comment": "kdGv",
	"./views/product/comment/": "kdGv",
	"./views/product/comment/detail": "6Bcg",
	"./views/product/comment/detail.vue": "6Bcg",
	"./views/product/comment/index": "kdGv",
	"./views/product/comment/index.vue": "kdGv",
	"./views/product/product": "K2Ek",
	"./views/product/product/": "K2Ek",
	"./views/product/product/add": "hFRD",
	"./views/product/product/add.vue": "hFRD",
	"./views/product/product/edit": "EyHQ",
	"./views/product/product/edit.vue": "EyHQ",
	"./views/product/product/index": "K2Ek",
	"./views/product/product/index.vue": "K2Ek",
	"./views/product/product/part/Basic": "YM4q",
	"./views/product/product/part/Basic.vue": "YM4q",
	"./views/product/product/part/Buyset": "mSDe",
	"./views/product/product/part/Buyset.vue": "mSDe",
	"./views/product/product/part/Content": "/Z9I",
	"./views/product/product/part/Content.vue": "/Z9I",
	"./views/product/product/part/Spec": "gpK8",
	"./views/product/product/part/Spec.vue": "gpK8",
	"./views/product/product/part/spec/Many": "u0Wf",
	"./views/product/product/part/spec/Many.vue": "u0Wf",
	"./views/product/product/part/spec/Single": "Hzzi",
	"./views/product/product/part/spec/Single.vue": "Hzzi",
	"./views/product/product/part/spec/many/Table": "TyLA",
	"./views/product/product/part/spec/many/Table.vue": "TyLA",
	"./views/product/product/part/spec/many/Type": "uX1f",
	"./views/product/product/part/spec/many/Type.vue": "uX1f",
	"./views/setting/address": "TPSk",
	"./views/setting/address/": "TPSk",
	"./views/setting/address/add": "zk+C",
	"./views/setting/address/add.vue": "zk+C",
	"./views/setting/address/edit": "zdIE",
	"./views/setting/address/edit.vue": "zdIE",
	"./views/setting/address/index": "TPSk",
	"./views/setting/address/index.vue": "TPSk",
	"./views/setting/delivery": "rHZr",
	"./views/setting/delivery/": "rHZr",
	"./views/setting/delivery/add": "ic2S",
	"./views/setting/delivery/add.vue": "ic2S",
	"./views/setting/delivery/dialog/Area": "57SA",
	"./views/setting/delivery/dialog/Area.vue": "57SA",
	"./views/setting/delivery/edit": "mgbR",
	"./views/setting/delivery/edit.vue": "mgbR",
	"./views/setting/delivery/index": "rHZr",
	"./views/setting/delivery/index.vue": "rHZr",
	"./views/setting/express": "VnVr",
	"./views/setting/express/": "VnVr",
	"./views/setting/express/index": "VnVr",
	"./views/setting/express/index.vue": "VnVr",
	"./views/setting/fullfree": "uH4+",
	"./views/setting/fullfree/": "uH4+",
	"./views/setting/fullfree/index": "uH4+",
	"./views/setting/fullfree/index.vue": "uH4+",
	"./views/setting/fullreduce": "dBFk",
	"./views/setting/fullreduce/": "dBFk",
	"./views/setting/fullreduce/Add": "e3Hc",
	"./views/setting/fullreduce/Add.vue": "e3Hc",
	"./views/setting/fullreduce/Edit": "+hlx",
	"./views/setting/fullreduce/Edit.vue": "+hlx",
	"./views/setting/fullreduce/index": "dBFk",
	"./views/setting/fullreduce/index.vue": "dBFk",
	"./views/setting/printer": "ZB/9",
	"./views/setting/printer/": "ZB/9",
	"./views/setting/printer/add": "i1Js",
	"./views/setting/printer/add.vue": "i1Js",
	"./views/setting/printer/edit": "GMCA",
	"./views/setting/printer/edit.vue": "GMCA",
	"./views/setting/printer/index": "ZB/9",
	"./views/setting/printer/index.vue": "ZB/9",
	"./views/setting/printing": "8/jR",
	"./views/setting/printing/": "8/jR",
	"./views/setting/printing/index": "8/jR",
	"./views/setting/printing/index.vue": "8/jR",
	"./views/setting/service": "3Azt",
	"./views/setting/service/": "3Azt",
	"./views/setting/service/index": "3Azt",
	"./views/setting/service/index.vue": "3Azt",
	"./views/setting/supplier": "vQRY",
	"./views/setting/supplier/": "vQRY",
	"./views/setting/supplier/index": "vQRY",
	"./views/setting/supplier/index.vue": "vQRY",
	"./views/shop/security": "LL95",
	"./views/shop/security/": "LL95",
	"./views/shop/security/index": "LL95",
	"./views/shop/security/index.vue": "LL95",
	"./views/statistics": "meih",
	"./views/statistics/": "meih",
	"./views/statistics/index": "meih",
	"./views/statistics/index.vue": "meih",
	"./views/statistics/sales": "b2HO",
	"./views/statistics/sales/": "b2HO",
	"./views/statistics/sales/index": "b2HO",
	"./views/statistics/sales/index.vue": "b2HO",
	"./views/statistics/sales/part/Product": "g9si",
	"./views/statistics/sales/part/Product.vue": "g9si",
	"./views/statistics/sales/part/Total": "qeIQ",
	"./views/statistics/sales/part/Total.vue": "qeIQ",
	"./views/statistics/sales/part/Transaction": "vrct",
	"./views/statistics/sales/part/Transaction.vue": "vrct",
	"./views/statistics/sales/part/product/LineChart": "m4n9",
	"./views/statistics/sales/part/product/LineChart.vue": "m4n9",
	"./views/statistics/sales/part/product/Ranking": "MdEo",
	"./views/statistics/sales/part/product/Ranking.vue": "MdEo",
	"./views/statistics/sales/part/product/Total": "XACy",
	"./views/statistics/sales/part/product/Total.vue": "XACy",
	"./views/statistics/user": "H8Xp",
	"./views/statistics/user/": "H8Xp",
	"./views/statistics/user/index": "H8Xp",
	"./views/statistics/user/index.vue": "H8Xp",
	"./views/statistics/user/part/LineChart": "Avhs",
	"./views/statistics/user/part/LineChart.vue": "Avhs",
	"./views/statistics/user/part/Pie": "jenl",
	"./views/statistics/user/part/Pie.vue": "jenl",
	"./views/statistics/user/part/Ranking": "iYFu",
	"./views/statistics/user/part/Ranking.vue": "iYFu",
	"./views/statistics/user/part/Total": "MCBO",
	"./views/statistics/user/part/Total.vue": "MCBO",
	"./views/store/clerk": "UEOG",
	"./views/store/clerk/": "UEOG",
	"./views/store/clerk/add": "V3Z5",
	"./views/store/clerk/add.vue": "V3Z5",
	"./views/store/clerk/edit": "KoDE",
	"./views/store/clerk/edit.vue": "KoDE",
	"./views/store/clerk/index": "UEOG",
	"./views/store/clerk/index.vue": "UEOG",
	"./views/store/order": "dyrO",
	"./views/store/order/": "dyrO",
	"./views/store/order/index": "dyrO",
	"./views/store/order/index.vue": "dyrO",
	"./views/store/store": "kc4o",
	"./views/store/store/": "kc4o",
	"./views/store/store/add": "US/d",
	"./views/store/store/add.vue": "US/d",
	"./views/store/store/edit": "kvzN",
	"./views/store/store/edit.vue": "kvzN",
	"./views/store/store/index": "kc4o",
	"./views/store/store/index.vue": "kc4o"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mw/N";


//////////////////
// WEBPACK FOOTER
// ./src ^\.\/views.*$
// module id = mw/N
// module chunks = 1